// @flow
export const ORDER_STATUS_NEW = 'NEW'
export const ORDER_STATUS_PROCESSING = 'PROCESSING'
export const ORDER_STATUS_CLOSED = 'CLOSED'
export type OrderStatus = 'NEW' | 'PROCESSING' | 'CLOSED'
export const Mapping = {
  NEW: 'NEW',
  PROCESSING: 'PROCESSING',
  CLOSED: 'PROCESSING'
}



// WEBPACK FOOTER //
// ./src/types/order-status.js